import React from 'react';
import Widget from 'components/ui/layout/panel/Widget';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template no-modal">
        <Widget>
            <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'CMDB'})}</h1>
            <p>{formatMessage({id: 'error.PERMISSION_DENIED'})}</p>
        </Widget>
        <Widget className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </Widget>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/cmdb.js